import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  selectOrganization: {
    id: 'organizations.select.header',
    defaultMessage: 'Select an Organization',
  },
});

export default messages; 